export const FETCHING = 'FETCHING'
export const IDLE = 'IDLE'
export const LOADING = 'LOADING'
export const SUBMITTING = 'SUBMITTING'
